module.exports = __webpack_public_path__ + "img/Xero.39a0952b.svg";